import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type StartInvoicePayLinkCheckoutMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type StartInvoicePayLinkCheckoutMutation = { __typename?: 'Mutation', startInvoicePayLinkCheckout: { __typename?: 'PublicInvoiceCheckoutStartPayload', tokenState: Types.PublicInvoicePayLinkTokenState, checkoutUrl?: string | null, payLink?: { __typename?: 'PublicInvoicePayLink', tokenState: Types.PublicInvoicePayLinkTokenState, onlinePaymentAvailable: boolean, newLinkAvailable: boolean, grower?: { __typename?: 'PublicInvoicePayLinkGrower', displayName: string, logoUrl?: string | null, primaryColorHex?: string | null, email?: string | null, phone?: string | null } | null, invoice?: { __typename?: 'PublicInvoicePayLinkInvoice', invoiceNumber: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, currency: string, total: number, postedBalance: number, pendingAmount: number, lastFailure?: string | null, openAttemptStatus?: Types.PaymentAttemptStatus | null, quote: { __typename?: 'InvoicePaymentQuote', postedBalance: number, discount: number, lateCharge: number, payableAmount: number, currency: string, quotedAt: Types.TDateISO, expiresAt: Types.TDateISO } } | null } | null, refusal?: { __typename?: 'InvoiceCheckoutRefusal', code: Types.InvoiceCheckoutRefusalCode, retryable: boolean, linkBound: boolean, linkExpiresAt?: Types.TDateISO | null } | null } };

export type RequestInvoicePayLinkResendMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type RequestInvoicePayLinkResendMutation = { __typename?: 'Mutation', requestInvoicePayLinkResend: { __typename?: 'RequestInvoicePayLinkResendPayload', accepted: boolean } };


export const StartInvoicePayLinkCheckoutDocument = new TypedDocumentString(`
    mutation StartInvoicePayLinkCheckout($token: String!) {
  startInvoicePayLinkCheckout(token: $token) {
    tokenState
    checkoutUrl
    payLink {
      ...PublicPayLinkFields
    }
    refusal {
      code
      retryable
      linkBound
      linkExpiresAt
    }
  }
}
    fragment PublicPayLinkFields on PublicInvoicePayLink {
  tokenState
  onlinePaymentAvailable
  newLinkAvailable
  grower {
    ...PublicPayLinkGrowerFields
  }
  invoice {
    invoiceNumber
    invoiceDate
    dueDate
    currency
    total
    postedBalance
    pendingAmount
    lastFailure
    openAttemptStatus
    quote {
      postedBalance
      discount
      lateCharge
      payableAmount
      currency
      quotedAt
      expiresAt
    }
  }
}
fragment PublicPayLinkGrowerFields on PublicInvoicePayLinkGrower {
  displayName
  logoUrl
  primaryColorHex
  email
  phone
}`);
export const RequestInvoicePayLinkResendDocument = new TypedDocumentString(`
    mutation RequestInvoicePayLinkResend($token: String!) {
  requestInvoicePayLinkResend(token: $token) {
    accepted
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    StartInvoicePayLinkCheckout: build.mutation<StartInvoicePayLinkCheckoutMutation, StartInvoicePayLinkCheckoutMutationVariables>({
      query: (variables) => ({ document: StartInvoicePayLinkCheckoutDocument, variables })
    }),
    RequestInvoicePayLinkResend: build.mutation<RequestInvoicePayLinkResendMutation, RequestInvoicePayLinkResendMutationVariables>({
      query: (variables) => ({ document: RequestInvoicePayLinkResendDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useStartInvoicePayLinkCheckoutMutation, useRequestInvoicePayLinkResendMutation } = injectedRtkApi;
